// extracted by mini-css-extract-plugin
module.exports = {"Icons":"Icons_Icons__2fkw1","image":"Icons_image__2KZgX"};